module.exports = __webpack_public_path__ + "static/media/8.f1c90963.svg";